import CustomerVehicleList from './CustomerVehicleList';

export default CustomerVehicleList;



// WEBPACK FOOTER //
// ./src/components/molecules/CustomerVehicleList/index.js